<template>
	<div>
		<v-dialog v-model="$parent.dialog_transaction_list" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Select Transaction Type</v-subheader>
	        	</v-card-title>

	        	<v-divider></v-divider>
	        	
		        <v-card-text full-height nopadding>

			        <v-list nopadding>
			        	 <v-list-tile norightpadding v-for="(item, index) in transactionForms" :key="index" @click="selectItems(item.id)" v-if="!item.hidden">
				            <v-list-tile-content>
				            	<v-list-tile-title>{{item.title}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action class="list-checkbox">
				              <v-checkbox v-model="selectedTransactionListIds" :value="item.id" readonly></v-checkbox>
				            </v-list-tile-action>
				        </v-list-tile>
			        </v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
		        	<v-btn small color="blue darken-1" flat v-if="selectedTransactionListIds.length" @click="clearAll">clear all</v-btn>
          			<v-btn small color="blue darken-1" flat @click="$parent.dialog_transaction_list = false">Done</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>

	export default{
		props:['transactionForms', 'selectedTransactionListIds', 'selectItems', 'clearAll']
	}
</script>


// WEBPACK FOOTER //
// src/components/activity/dialogs/dialog_transaction_list.vue